<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="page-header">
        <div>
          <div class="page-title">APP 管理仪表盘</div>
          <div class="page-subtitle">快乐星姬天制作委员会 · 待处理内容总览</div>
        </div>
        <el-button type="primary" icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>

      <el-row :gutter="16" class="metric-row">
        <el-col :span="8" v-for="item in metrics" :key="item.key">
          <div class="metric-card" :class="item.className">
            <div class="metric-icon">
              <i :class="item.icon"></i>
            </div>
            <div>
              <div class="metric-value">{{ dashboard[item.key] || 0 }}</div>
              <div class="metric-label">{{ item.label }}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-alert
        title="处理顺序建议"
        description="优先处理待审核帖子、楼层与举报；封禁用户和权限调整可在 APP 用户管理中完成。"
        type="info"
        :closable="false"
        show-icon
      />
    </div>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { isSuccess } from "./appAdminUtils.js";

export default {
  name: "appDashboard",
  data() {
    return {
      dashboard: {},
      metrics: [
        { key: "total_users", label: "APP总用户", icon: "el-icon-user-solid", className: "cyan" },
        { key: "bound_bilibili_users", label: "已绑定B站", icon: "el-icon-link", className: "blue" },
        { key: "total_posts", label: "论坛主题总数", icon: "el-icon-collection", className: "purple" },
        { key: "pending_posts", label: "待审核帖子", icon: "el-icon-document", className: "cyan" },
        { key: "pending_floors", label: "待审核楼层", icon: "el-icon-chat-line-square", className: "blue" },
        { key: "pending_floor_replies", label: "待审核楼中楼", icon: "el-icon-chat-dot-square", className: "purple" },
        { key: "pending_reports", label: "待处理举报", icon: "el-icon-warning-outline", className: "orange" },
        { key: "pending_messages", label: "待审核留言", icon: "el-icon-message", className: "orange" },
        { key: "today_posts", label: "24小时新主题", icon: "el-icon-edit-outline", className: "green" },
        { key: "today_chats", label: "24小时私聊", icon: "el-icon-chat-dot-round", className: "blue" },
        { key: "today_users", label: "24小时新增用户", icon: "el-icon-user", className: "green" },
        { key: "banned_users", label: "封禁用户", icon: "el-icon-lock", className: "red" },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      post("/api/admin/app/dashboard", {}).then((res) => {
        if (isSuccess(res)) {
          this.dashboard = res.data.data || {};
        } else {
          this.$message.error(res.data.msg || "仪表盘数据获取失败");
        }
      });
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 94%;
  min-height: 88%;
  margin: 1.5% auto;
  padding: 24px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
}
.page-title {
  font-size: 22px;
  color: #1f2d3d;
  font-weight: 700;
}
.page-subtitle {
  color: #7f8fa4;
  margin-top: 6px;
}
.metric-row {
  margin-bottom: 22px;
}
.metric-card {
  height: 118px;
  display: flex;
  align-items: center;
  padding: 0 22px;
  margin-bottom: 16px;
  border-radius: 8px;
  color: #fff;
  box-sizing: border-box;
}
.metric-icon {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  font-size: 26px;
}
.metric-value {
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
}
.metric-label {
  margin-top: 10px;
  font-size: 14px;
}
.cyan {
  background: linear-gradient(135deg, #16b7b5, #21d4b6);
}
.blue {
  background: linear-gradient(135deg, #3182ce, #63b3ed);
}
.purple {
  background: linear-gradient(135deg, #805ad5, #b794f4);
}
.orange {
  background: linear-gradient(135deg, #ed8936, #f6ad55);
}
.green {
  background: linear-gradient(135deg, #38a169, #68d391);
}
.red {
  background: linear-gradient(135deg, #e53e3e, #fc8181);
}
</style>
